import { getTheme } from "@clipboard-health/ui-theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { SendbirdProvider } from "@sendbird/uikit-react/SendbirdProvider";
import { Route, useRouteMatch } from "react-router-dom";

import { environmentConfig } from "../environment";
import { useDefinedWorker } from "../Worker/useDefinedWorker";
import { ChatroomDetailPage } from "./ChatroomDetailPage";
import { ChatroomPageContainer } from "./Page";

export function ChatroomRoutesContainer(): JSX.Element {
  const worker = useDefinedWorker();
  const match = useRouteMatch();

  return (
    <SendbirdProvider
      appId={environmentConfig.REACT_APP_SENDBIRD_CHATROOMS_APP_ID}
      userId={worker.userId}
      nickname={`${worker.firstName ?? ""} ${worker.lastName?.charAt(0) ?? ""}.`}
    >
      <ThemeProvider theme={getTheme()}>
        <CssBaseline />
        <Route exact path={`${match.url}/:chatroomId`}>
          <ChatroomDetailPage />
        </Route>
        <Route>
          <ChatroomPageContainer />
        </Route>
      </ThemeProvider>
    </SendbirdProvider>
  );
}
